import Image from "next/image";
import { Box, Link } from "@mui/material";
import { COLOR_CONSTANTS } from "../../../../constants/styles";

export type SidebarHeaderProps = {
  onHomeClick?: () => void;
  /** true 면 홈 링크 클릭을 비활성화한다 */
  disabled?: boolean;
};

export function SidebarHeader({ onHomeClick, disabled }: SidebarHeaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        height: "40px",
        backgroundColor: COLOR_CONSTANTS.action.hover,
      }}
    >
      <Link
        component="button"
        disabled={disabled}
        onClick={disabled ? undefined : onHomeClick}
        sx={{
          color: "#424242",
          fontSize: 12,
          fontWeight: 500,
          textDecoration: "none",
          cursor: disabled ? "default" : "pointer",
        }}
      >
        <Image src="/icons/logo/name.svg" alt="home" width={60} height={9} />
      </Link>
    </Box>
  );
}
